enum LoginWizardStep {
    EMAIL = 1,
    PASSWORD = 2,
    BLOCKED = 3,
}

export { LoginWizardStep };
